import { render, staticRenderFns } from "./custom-group-report.vue?vue&type=template&id=9d70500a&scoped=true"
import script from "./custom-group-report.vue?vue&type=script&lang=js"
export * from "./custom-group-report.vue?vue&type=script&lang=js"
import style0 from "./custom-group-report.vue?vue&type=style&index=0&id=9d70500a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d70500a",
  null
  
)

export default component.exports